export default "__VITE_ASSET__5J$Jd_ff__"